import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';
import moment from 'moment';

export const REPORT_CHILDREN_REQUEST = 'REPORT_CHILDREN_REQUEST';
export const REPORT_CHILDREN_SUCCESS = 'REPORT_CHILDREN_SUCCESS';
export const REPORT_CHILDREN_FAILURE = 'REPORT_CHILDREN_FAILURE';

export const REPORT_CHILDREN_EXPORT_REQUEST = 'REPORT_CHILDREN_EXPORT_REQUEST';
export const REPORT_CHILDREN_EXPORT_SUCCESS = 'REPORT_CHILDREN_EXPORT_SUCCESS';
export const REPORT_CHILDREN_EXPORT_FAILURE = 'REPORT_CHILDREN_EXPORT_FAILURE';

export const loadReportChildren = (options, type) => ({
	[CALL_API]: {
		types: [REPORT_CHILDREN_REQUEST, REPORT_CHILDREN_SUCCESS, REPORT_CHILDREN_FAILURE],
		endpoint: `api/reports/parents/${type}`,
		request: options,
		schema: Schemas.REPORT_CHILDREN,		
		replace: {
			replace: true,
			entityForReplace: 'reportChildrenSummary',
			keyForReplace: 'type',
			valueForReplace: type
		},
		resultIds: (result) => result.parents,
		form: 'reportChildrenDetailsFilter'
	},
	reportType: type
});

export const exportReportChildren = (options, type, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [REPORT_CHILDREN_EXPORT_REQUEST, REPORT_CHILDREN_EXPORT_SUCCESS, REPORT_CHILDREN_EXPORT_FAILURE],
			endpoint: `api/reports/parents/${type}/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `${type}Report-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}